"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KISTLER_ID_AUTHENTICATION_PROVIDER = exports.authProvidersClassNames = exports.LOCKOUT_END_VALUE = exports.VIEW_USER_MODAL_KEY = exports.CHANGE_PASSWORD_MODAL_KEY = exports.CREATE_USER_MODAL_KEY = exports.USER_STATE_KEYS = exports.USERS_STATE_KEY_NAME = void 0;
var USERS_STATE_KEY_NAME = 'users';
exports.USERS_STATE_KEY_NAME = USERS_STATE_KEY_NAME;
var USER_STATE_KEYS = {
  CREATE_USER: 'createUser',
  UPDATE_USER: 'updateUser',
  VIEW_USER: 'viewUser',
  CHANGE_PASSWORD: 'changePassword',
  LIST: 'list'
};
exports.USER_STATE_KEYS = USER_STATE_KEYS;
var CREATE_USER_MODAL_KEY = 'create-user-modal';
exports.CREATE_USER_MODAL_KEY = CREATE_USER_MODAL_KEY;
var CHANGE_PASSWORD_MODAL_KEY = 'change-password-modal';
exports.CHANGE_PASSWORD_MODAL_KEY = CHANGE_PASSWORD_MODAL_KEY;
var VIEW_USER_MODAL_KEY = 'view-user-modal';
exports.VIEW_USER_MODAL_KEY = VIEW_USER_MODAL_KEY;
var LOCKOUT_END_VALUE = '9999-12-31T23:59:59.9999999+00:00';
exports.LOCKOUT_END_VALUE = LOCKOUT_END_VALUE;
var authProvidersClassNames = ['blue-100', 'olive-100', 'orchid-100', 'royal-100', 'cadet-100', 'khaki-100', 'peru-100', 'firebrick-100'];
exports.authProvidersClassNames = authProvidersClassNames;
var KISTLER_ID_AUTHENTICATION_PROVIDER = 'KistlerID';
exports.KISTLER_ID_AUTHENTICATION_PROVIDER = KISTLER_ID_AUTHENTICATION_PROVIDER;
//# sourceMappingURL=constants.js.map